import React from "react";
import '../Styles/not-found.css';

export default function NotFoundPage()
{
    return(
     <div className={'not-found'}>
        <div className={'text-img'}>
            <img className={'img-not-found'} src={"./Images/img-404.webp"}/>
            <p className={"text-not-found text"}>
                <span className={'txt-1'}>
                    Oups...
                </span>
                <br/>
                <span className={'txt-2'}>
                    Ce n'est pas ce que vous cherchez
                </span>
            </p>
        </div>
     </div>
    )
}